module.exports = __webpack_public_path__ + "img/open.fc1ff9e5.png";